module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/landings/landing-list/landing-list.component.scss
// module id = ./libs/atenea-cms-brand/src/landings/landing-list/landing-list.component.scss
// module chunks = main